import React from 'react';
import { STYLES } from '../button/constants';
import CameraGraphicSvg from '../iconography/icons/CameraGraphic';
export var PRIMARY_TYPES = STYLES;
export var DEFAULT_GRAPHIC = React.createElement(CameraGraphicSvg, null);
export var DEFAULT_TYPE = 'fill';